import { render } from "./addShop.vue?vue&type=template&id=71d09ef5&scoped=true"
import script from "./addShop.vue?vue&type=script&lang=js"
export * from "./addShop.vue?vue&type=script&lang=js"

import "./addShop.vue?vue&type=style&index=0&id=71d09ef5&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71d09ef5"]])

export default __exports__